import useSWR from 'swr';
import config from '../config';

function useMenus() {
    const { data, error, isLoading } = useSWR(
        'menuData',
        () => fetch(`${config.apiUrl}/menu`).then(res => res.json()),
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        });
    return {
      menus: data?.data,
      isLoading,
      isError: error,
    }
}

function useMenu(menuId) {
    const { data, error, isLoading } = useSWR(
        'singleMenuData',
        () => fetch(`${config.apiUrl}/menu/${menuId}`).then(res => res.json()),
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        });
    console.log({data})
    return {
        menu: data?.data,
        isLoading,
        isError: error,
    }
}

export { useMenus, useMenu };
